<script>
import Batches from '@/layer/components/Batches.vue'

export default {
  components: {
    Batches,
  },
}
</script>

<template>
  <batches />
</template>



// WEBPACK FOOTER //
// src/layer/views/BatchesView.vue